/* eslint-disable spire/export-styles */
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal, {
    ProductSelectorVariantModalStyles,
} from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const productSelectorVariantModalExtendedStyles: ProductSelectorVariantModalStyles = {
    modal: {
        size: 500,
        cssOverrides: {
            modalContent: css`
                padding: 20px;
                text-align: center;
            `,
        },
    },
    variantSelect: {
        labelProps: {
            css: css`
                width: 50%;
                text-align: left;
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                width: 50%;
            `,
        },
    },
    selectButton: {
        css: css`
            width: 25%;
            margin-top: 10px;
        `,
    },
};

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => (
    <>
        <AddToListModal />
        <ShareListModal />
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal
            skipInventoryValidation={skipInventoryValidation}
            skipProductPrice={skipProductPrice}
            extendedStyles={productSelectorVariantModalExtendedStyles}
        />
        <ProductDeliveryScheduleModal />
    </>
);

export default Modals;
